import type { ReactNode } from 'react';
import { Sheet } from './sheet';
import { Button, type ButtonVariant } from './button';

/**
 * A confirm/blocking dialog built on `Sheet` (bottom-sheet on mobile, centered dialog on desktop).
 * Body renders the details (refund breakdown, warning, etc.); the footer is a ghost cancel + a
 * primary/danger confirm. Omit `onConfirm` for a single-action informational block.
 */
export function ConfirmDialog({
  open,
  onClose,
  title,
  children,
  confirmLabel,
  cancelLabel = 'Cancel',
  confirmVariant = 'primary',
  onConfirm,
  busy = false,
}: {
  open: boolean;
  onClose: () => void;
  title: string;
  children?: ReactNode;
  confirmLabel: string;
  cancelLabel?: string;
  confirmVariant?: ButtonVariant;
  onConfirm?: () => void;
  busy?: boolean;
}) {
  return (
    <Sheet
      open={open}
      onClose={onClose}
      title={title}
      footer={
        <div className="wb-row wb-gap-8" style={{ justifyContent: 'flex-end' }}>
          {onConfirm && (
            <Button variant="ghost" onClick={onClose} disabled={busy}>
              {cancelLabel}
            </Button>
          )}
          <Button variant={confirmVariant} onClick={onConfirm ?? onClose} disabled={busy}>
            {confirmLabel}
          </Button>
        </div>
      }
    >
      {children}
    </Sheet>
  );
}
